// Local, inline generic avatar placeholders used as the *default* fallback for
// CMS "avatar" image fields (Home/About hero sections) before an admin uploads a
// real photo. Previously these fallbacks hotlinked to images.unsplash.com (F10) —
// third-party images that can disappear/change upstream and that aren't real
// students anyway. Data URIs keep this fully local with no network dependency.
const buildAvatar = (color) => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><rect width="48" height="48" rx="24" fill="${color}"/><circle cx="24" cy="19" r="8" fill="#FFFFFF" fill-opacity="0.92"/><path d="M8 43c0-9.4 7.2-16 16-16s16 6.6 16 16" fill="#FFFFFF" fill-opacity="0.92"/></svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const GENERIC_AVATARS = [
  buildAvatar('#1A2E6E'), // navy
  buildAvatar('#4CAF50'), // green
  buildAvatar('#F5A623'), // gold
  buildAvatar('#D72B2B'), // red
];
